import { TableList } from "./TableList";
import { useEffect, useState } from "react";
import { ColumnsModal } from "./ColumnsModal";
import { NoDatasets } from "./NoDatasets";
import { useLocation, useNavigate } from "react-router-dom";
import { useDatasetFilter } from "../../services/filters";
import {
  Card,
  CardContent,
  CardHeader,
  Sheet,
  SheetContent,
  Stack,
  Typography,
} from "@altimateai/lego";
import { useBreadcrumb } from "@/components/breadcrumbs";
import { TableItem } from "./types";
import DatasetsNewFilters from "./DatasetsNewFilters";

export function Datasets(): JSX.Element {
  useBreadcrumb("Datasets");

  const [search, setSearch] = useState<string>("");
  const { state } = useLocation();

  const navigate = useNavigate();
  const onDetailsClick = (table: TableItem) =>
    navigate(`/datasets/${table.id}`, { state: { from: "datasets" } });
  const [schemaTable, setSchemaTable] = useState<TableItem | null>(null);

  const { isDataset, tables, paginate, isTableLoading } = useDatasetFilter({
    search,
    defaultFilters: state?.filters || {},
  });
  useEffect(() => {
    if (!tables || tables.length === 0) return;
    if (!schemaTable) return;
    const t = tables.find((t: TableItem) => t.id === schemaTable.id);
    if (t) setSchemaTable(t);
  }, [tables, schemaTable]);

  if (isDataset) return <NoDatasets />;

  const tableListProps = {
    paginate: {
      ...paginate,
      itemCount: paginate.itemCount ?? 0,
    },
    tables,
    search,
    onDetailsClick,
    onItemClick: onDetailsClick,
    select: {
      label: "View Schema",
      outline: true,
      onSelect: (table: TableItem) => {
        setSchemaTable?.(table);
      },
    },
  };

  return (
    <>
      <div>
        <Stack className="mb-4" align="center" justify="between">
          <Stack align="start" direction="column">
            <Typography variant="page-heading">Datasets</Typography>
          </Stack>
        </Stack>
        <Card>
          <CardHeader>
            <Stack gap={"lg"} justify={"between"} className={"al-w-full"}>
              <DatasetsNewFilters onSearchChange={setSearch} />
            </Stack>
          </CardHeader>
          <CardContent>
            <Stack>
              <TableList isLoading={isTableLoading} {...tableListProps} />
            </Stack>
          </CardContent>
        </Card>
      </div>
      <Sheet open={!!schemaTable} onOpenChange={open => !open && setSchemaTable(null)}>
        <SheetContent side="right" className="!al-w-[446px]" aria-label="Dataset schema modal">
          <ColumnsModal table={schemaTable} onDetailsClick={onDetailsClick} />
        </SheetContent>
      </Sheet>
    </>
  );
}
